/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CrestaZoneResponseDto
 */
export interface CrestaZoneResponseDto {
    /**
     * The name of the cresta zone
     * @type {string}
     * @memberof CrestaZoneResponseDto
     */
    name: string;
    /**
     * The name of country of the cresta zone
     * @type {string}
     * @memberof CrestaZoneResponseDto
     */
    country: string;
    /**
     * Whether the cresta zone is active
     * @type {boolean}
     * @memberof CrestaZoneResponseDto
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the CrestaZoneResponseDto interface.
 */
export function instanceOfCrestaZoneResponseDto(value: object): value is CrestaZoneResponseDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function CrestaZoneResponseDtoFromJSON(json: any): CrestaZoneResponseDto {
    return CrestaZoneResponseDtoFromJSONTyped(json, false);
}

export function CrestaZoneResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrestaZoneResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'country': json['country'],
        'isActive': json['isActive'],
    };
}

export function CrestaZoneResponseDtoToJSON(json: any): CrestaZoneResponseDto {
    return CrestaZoneResponseDtoToJSONTyped(json, false);
}

export function CrestaZoneResponseDtoToJSONTyped(value?: CrestaZoneResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'country': value['country'],
        'isActive': value['isActive'],
    };
}

